import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const NosotrosPage = lazy(() => import('../pages/nosotros/page'));
const CertificacionOEAPage = lazy(() => import('../pages/certificacion-oea/page'));
const ComunicadosPage = lazy(() => import('../pages/comunicados/page'));
const PortalClientesPage = lazy(() => import('../pages/portal-clientes/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const CotizarPage = lazy(() => import('../pages/cotizar/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/inicio',
    element: <HomePage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />,
  },
  {
    path: '/certificacion-oea',
    element: <CertificacionOEAPage />,
  },
  {
    path: '/comunicados',
    element: <ComunicadosPage />,
  },
  {
    path: '/portal-clientes',
    element: <PortalClientesPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '/cotizar',
    element: <CotizarPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
